module.exports = __webpack_public_path__ + "media/79.5cabec30.mp3";